$(document).ready(function () {
    $(document).on('submit', '.contact-form',
        function (e) {
            e.preventDefault();
            var form = $('.contact-form');

            var submit = form.find('button[type="submit"]');
            var currentText;

            if (submit.length) {
                currentText = submit.text();
                submit.text("Submitting...");
            } else {
                submit = form.find("input[type='submit']");
                currentText = submit.text();
                submit.val("Submitting...");
            }
            submit.attr("disabled", true);
            form.find('.response-holder').html('');
            $.ajax({
                type: "POST",
                url: form.prop('action'),
                data: form.serializeArray(),
                success: function (data) {
                    submit.removeAttr("disabled");
                    if (submit.is("input")) {
                        submit.val(currentText);
                    } else {
                        submit.text(currentText);
                    }
                    if (data.SaveSuccessful) {
                        window.location = $('.contact-form').data('completeurl');
                    } else {
                        form.find('.response-holder').html('<p class="alert alert-danger" style="display: block;"><span class="icon_holder"><i class="icon-warning-sign"></i> There was an issue submitting your details. Please try again.</span></p>');
                        submit.removeAttr("disabled");
                        if (submit.is("input")) {
                            submit.val(currentText);
                        } else {
                            submit.text(currentText);
                        }
                    }
                },
                error: function () {
                    submit.removeAttr("disabled");
                    if (submit.is("input")) {
                        submit.val(currentText);
                    } else {
                        submit.text(currentText);
                    }
                }
            });
        });
});